import { EsDataType } from '../../enums';
import { sharedCustomsEntryColumns } from './sharedCustomsEntry';
import { createShipmentWorkOrderRecord } from './utils';
import { Stage } from '@xbcb/shared-types';
import { getEnv } from '@xbcb/core';

const { stage } = getEnv();

export const gbCustomsEntry = createShipmentWorkOrderRecord({
  columns: {
    ...sharedCustomsEntryColumns,
    importEntryNumbers: {
      hidden: stage === Stage.PROD,
      name: 'Import Entry Numbers',
      type: EsDataType.TEXT,
    },
  },
});
